import React from "react"
import { Link } from "gatsby"

import SVG from "react-inlinesvg"
import styles from "./footer.module.scss"
const logoScript = require("../../assets/images/logo-script.svg")

const Footer = () => (
  <>
    <footer className={styles.container} id="contact">
      <div className={styles.logo}>
        <SVG src={logoScript} className={styles.logoImage} />
        <span className={styles.logoTagline}>
          Brands.
          <br /> Built on
          <br /> behaviour.
        </span>
      </div>

      <address className={styles.address}>
        <div className={styles.addressColumn}>
          <Link to={`/contact/`} className={`${styles.addressLink} display5 uppercase hover-target`}>
            Contact
          </Link>
        </div>
      </address>

      <div className={styles.links}>
        <p
          className={`body3 ${styles.welcomeToCountry__desktop}`}
          style={{ color: "#656565" }}
        >
          In Naarm (Melbourne), we acknowledge that our office is located on
          Traditional Lands of the Wurundjeri people of the Kulin Nations. In
          Cadi (Sydney), we acknowledge that our office is located on
          Traditional Lands of the Gadigal people of the Eora nation. We pay our
          respect to their Elders past, present and emerging. We extend that
          respect to all Aboriginal and Torres Strait Islander peoples.
        </p>
        <Link to={`/contact/`} className={styles.careersLink}>
          Let's chat
        </Link>
        <div className={styles.connect}>
          <span className={styles.connectTitle}>Connect</span>
          <a
            target="_blank"
            href="https://www.facebook.com/hardhatagency/"
            className={styles.connectLink}
          >
            Fb
          </a>
          <a
            target="_blank"
            href="https://www.linkedin.com/company/hardhatagency/"
            className={styles.connectLink}
          >
            Li
          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/hardhatagency/"
            className={styles.connectLink}
          >
            In
          </a>
        </div>
      </div>
      <p
        className={`body3 ${styles.welcomeToCountry__device}`}
        style={{ color: "#656565" }}
      >
        In Naarm (Melbourne), we acknowledge that our office is located on
        Traditional Lands of the Wurundjeri people of the Kulin Nations. In Cadi
        (Sydney), we acknowledge that our office is located on Traditional Lands
        of the Gadigal people of the Eora nation. We pay our respect to their
        Elders past, present and emerging. We extend that respect to all
        Aboriginal and Torres Strait Islander peoples.
      </p>
    </footer>
  </>
)

export default Footer
